export default function TorreMM() {
    return (
        <iframe
            title="PDF Torremm"
            height="100"
            width="100"
            style={{ width: "100%", height: "100vh" }}
            src="https://media.grupoguia.mx/assets/home-page/pdf/ubicacion_torremm.pdf"
            frameborder="0"
            allowFullScreen="true"
        />
    );
}
